import moment from 'moment';

export const getFileName = (name: string): string => {
  return [
    // replace all whitespaces
    name.replace(/\s/g, '_'),
    '_',
    moment().format('DD.MM.YYYY'),
    '.xlsx',
  ].join('');
};
